import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getApiParams } from "../../redux/auth";
import { BodyType } from "../../redux/base/request";
import { getLocalized } from "../../redux/localization";
import { BaseService } from "../../services";
import { Dashboard } from "./types";
import { DashboardCardObject } from "./types";
import "./style.scss";
import { baseUrl } from "../../services/urls";
import CountUp from "react-countup";

const DashboardCounts = () => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const baseService = new BaseService();
  const { token, lang } = useSelector(getApiParams);
  const [datas, setDatas] = useState<Dashboard>();
  const localize = useSelector(getLocalized);

  const getCounts = useCallback(async () => {
    const res: any | null = await baseService.sendRequestWithApiResponse(
      baseUrl + "api/admin/dashboard/get-counts",
      "GET",
      token,
      lang,
      BodyType.formdata
    );
    if (res) {
      setDatas(res.Result);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, lang]);

  useEffect(() => {
    getCounts();
  }, [getCounts]);
  const customerActivitiesData: DashboardCardObject[] = [
    {
      id: "4",
      number: datas?.TotalAccount,
      title: localize.getString("totalUser"),
      icon: "user",
    },
    {
      id: "1",
      number: datas?.TotalProduct,
      title: localize.getString("totalProduct"),
      icon: "product",
    },
    {
      id: "2",
      number: datas?.TotalContract,
      title: localize.getString("totalContract"),
      icon: "textdocument",
    },
    {
      id: "3",
      number: datas?.TotalOpenTicket,
      title: localize.getString("ticket"),
      icon: "message",
    },
    {
      id: "5",
      number: datas?.TotalRequestContract,
      title: localize.getString("totalRequestContract"),
      icon: "comment",
    },
    {
      id: "6",
      number: datas?.TotalOpenContract,
      title: localize.getString("totalOpenContract"),
      icon: "file",
    },
  ];
  return (
    <div className={"content-flex2"}>
      {customerActivitiesData.map((data, key) => (
        <div className="home-count-cards">
          <i
            className={`dx-icon dx-icon-${data.icon}`}
            style={{ fontSize: 40 }}
          ></i>
          <p className="home-count-title">{data.title}</p>

          <CountUp
            className="home-count-number"
            start={0}
            end={data.number}
            duration={1}
          />
        </div>
        // <div
        //   key={key}
        //   className={"dx-card small-responsive-paddings"}
        //   style={{ color: data.color }}
        // >
        //   <i
        //     className={`dx-icon dx-icon-${data.icon}`}
        //     style={{ fontSize: 40 }}
        //   />
        //   <p style={{ marginBlockEnd: 10 }}>{data.title}</p>
        //   <p className="h4">{data.number}</p>
        // </div>
      ))}
    </div>
  );
};
export default DashboardCounts;
